import { tvpil } from '../compat/tvpil';

import { prefetchChannelsPersonalization } from './personalization/prefetchChannelsPersonalization';
import { prefetchChannelCollectionQuery } from './queries';
import { getChannelsSettings } from './settings';

type PrefetchChannelsArgs = {
  referenceId: string;
};

export function prefetchChannels({ referenceId }: PrefetchChannelsArgs) {
  if (!tvpil.userId) {
    return Promise.resolve();
  }

  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  if (!category) {
    return Promise.resolve();
  }

  const settings = getChannelsSettings(category);

  if (!settings || !settings.collectionId) {
    return Promise.resolve();
  }

  return Promise.all([prefetchChannelCollectionQuery({ settings }), prefetchChannelsPersonalization()]);
}
